<!--
배송등록(수동) 에서 사용되는 하우스정보 컴포넌트

-->
<template>
    <div class="house-component">


        <div class="uk-flex uk-flex-top">
            <div class="uk-width-expand mr-1rem">
                <!-- 받는사람 -->
                <app-shipping-reg-fieldset class="mb-1rem receive" title="받는사람">
                    <div class="uk-flex uk-flex-wrap uk-flex-top">

                        <div slot="title-desc" class="text-gray">(운송장에 출력되는 항목입니다. 정확하게 기입하세요)</div>

                        <!-- STOCK 안내문 -->
                        <div class="font-size-0d875rem uk-text-right">
                            <i class="material-icons">info</i>
                            수취인이 정해지지 않은 경우 수취인을 STOCK 으로 입력 하세요(보류처리 됨)
                        </div>

                        <input-td-style
                            class="input w-full"

                            type="text"
                            input-size="small"

                            ref="h_name"
                            name="h_name"
                            v-model="columns.h_name"
                            :label="clearanceByBiz ? '수취인(사업자명)' : '수취인'"

                            :validate-rules="{required: true}"
                            required

                            highlight

                            placeholder="개인통관부호와 일치하는 정확한 이름"
                            desc-msg=""
                        > </input-td-style>




                        <!-- 사업자통관여부 -->
                        <label class="w-full" style="margin-bottom: 0.5rem; display: block">
                            <input class="uk-checkbox mr-0d5rem" type="checkbox" v-model="clearanceByBiz" />
                            사업자 통관 신청 (수취인은 사업자명 입력)
                        </label>
                        <input-td-style
                            v-if="clearanceByBiz"

                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_customs_biz_no"
                            name="h_customs_biz_no"
                            v-model="columns.h_customs_biz_no"
                            label="사업자번호"

                            required
                            highlight

                            placeholder="사업자통관시 사업자번호 입력해주세요"
                        > </input-td-style>


                        <input-td-style
                            v-if="! clearanceByBiz"

                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_customs_clearance_no"
                            name="h_customs_clearance_no"
                            v-model="columns.h_customs_clearance_no"

                            label="개인통관고유부호"

                            required
                            highlight

                            placeholder="개인통관고유부호는 P포함 13자리 입니다."
                            desc-msg=""
                        >
                            <clearance-checker
                                slot="additional"

                                class=""
                                ref="clearance-checker"

                                :name="columns.h_name"
                                :clearance-no="columns.h_customs_clearance_no"
                                :cell="columns.h_cell"
                                :zipcode="columns.h_zipcode"
                                :first-name="columns.h_customs_first_name"
                                :last-name="columns.h_customs_last_name"

                                :csrf-token="csrfToken"

                                :login-user-id="loginUserId"
                                :login-user-nick="loginUserNick"

                                @update-check-state="val => clearanceChecked.checkState = val"
                                @update-incorrect-msg="val => clearanceChecked.incorrectMsg = val"
                            ></clearance-checker>
                        </input-td-style>

                        <!-- 개인통관고유부호 검사결과 -->
                        <div v-if="! clearanceByBiz" class="w-full">
                            <div
                                class="uk-text-primary uk-text-right mb-0d5rem"
                                v-show="clearanceChecked.checkState === 'corrected'"
                            >
                                <i class="material-icons">done</i>
                                개인통관고유부호 : 일치
                            </div>
                            <div
                                class="uk-text-danger uk-text-right mb-0d5rem"
                                v-show="clearanceChecked.checkState === 'incorrected'"
                            >
                                <i class="material-icons">error</i>
                                개인통관고유부호 : 불일치
                                ({{ clearanceChecked.incorrectMsg }})
                            </div>
                        </div>





                        <input-td-style
                            v-if="! clearanceByBiz"

                            class="input uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="h_customs_first_name"
                            name="h_customs_first_name"
                            v-model="columns.h_customs_first_name"
                            label="영문 이름"

                            placeholder=""
                            desc-msg=""
                        > </input-td-style>

                        <input-td-style
                            v-if="! clearanceByBiz"

                            class="input uk-width-expand mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="h_customs_last_name"
                            name="h_customs_last_name"
                            v-model="columns.h_customs_last_name"
                            label="영문 성"

                            placeholder=""
                            desc-msg=""
                        > </input-td-style>





                        <input-td-style
                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_cell"
                            name="h_cell"
                            v-model="columns.h_cell"
                            label="핸드폰"

                            :validate-rules="{required: true}"
                            required
                            required-layout="label-highlight"

                            placeholder="정확한 핸드폰 연락처가 있어야 합니다"
                            desc-msg=""
                        > </input-td-style>





                        <input-td-style
                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_tel"
                            name="h_tel"
                            v-model="columns.h_tel"
                            label="전화"
                        > </input-td-style>



                        <input-td-style
                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_zipcode"
                            name="h_zipcode"
                            v-model="columns.h_zipcode"
                            label="우편번호"

                            :validate-rules="{required: true, format: /^[0-9]{5}$/}"
                            required
                            required-layout="label-highlight"

                            placeholder="반드시 5자리 우편번호"
                            desc-msg=""
                        >
                            <app-zipcode-search
                                slot="additional"
                                class="uk-button-small"
                                @found="foundZipcode"
                            ></app-zipcode-search>
                        </input-td-style>



                        <input-td-style
                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_addr1"
                            name="h_addr1"
                            v-model="columns.h_addr1"
                            label="주소"

                            :validate-rules="{required: true}"
                            required
                            required-layout="label-highlight"

                            placeholder="주소는 한글로 작성해 주세요"
                        > </input-td-style>

                        <input-td-style
                            class="input w-full"
                            type="text"
                            input-size="small"

                            ref="h_addr2"
                            name="h_addr2"
                            v-model="columns.h_addr2"
                            label="상세주소"

                            placeholder="동,호수까지 정확하게 입력하세요"
                        > </input-td-style>


                        <input-td-style
                            class="input w-full"
                            type="textarea"
                            input-size="small"

                            ref="h_sp_memo"
                            name="h_sp_memo"
                            v-model="columns.h_sp_memo"
                            label="배송요청사항"

                            :textarea-rows="3"
                            placeholder="운송장에 출력되는 택배기사님 전달 내용입니다"
                        > </input-td-style>


                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="h_sp_code"
                            name="h_sp_code"
                            v-model="columns.h_sp_code"
                            label="합배송코드"

                            desc-msg="주의) 같은 코드끼리 합배송처리"
                        > </input-td-style>
                    </div>



                </app-shipping-reg-fieldset>
            </div>


            <div class="w-35rem mr-1rem">
                <!-- 보내는사람 -->
                <app-shipping-reg-fieldset class="mb-1rem send" title="보내는사람">
                    <div class="uk-text-right">
                        <a target="_blank" href="/my/user/default-house-info/edit">
                            <i class="material-icons">forward</i>
                            보내는사람 기본정보 수정하기
                        </a>
                    </div>
                    <input-td-style
                        class="input"
                        type="text"
                        input-size="small"

                        ref="h_send_name"
                        name="h_send_name"
                        v-model="columns.h_send_name"
                        label="발송인"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-highlight"

                        placeholder="회원사 영문명 (예를들어 TESTSHOP)"
                        desc-msg="업체영문 상호, 운송장에 표시됩니다"
                    > </input-td-style>

                    <input-td-style
                        class="input"
                        type="text"
                        input-size="small"

                        ref="h_send_tel"
                        name="h_send_tel"
                        v-model="columns.h_send_tel"
                        label="연락처"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-highlight"

                        placeholder="회원사 연락처"
                        desc-msg="업체연락처, 운송장에 표시됩니다."
                    > </input-td-style>

                </app-shipping-reg-fieldset>


                <!-- 판매자정보 -->
                <app-shipping-reg-fieldset class="mb-1rem etc" title="판매자정보">
                    <input-td-style
                        class="input"
                        type="radio"
                        input-size="small"

                        ref="h_customs_ecommerce_type"
                        name="h_customs_ecommerce_type"
                        v-model="columns.h_customs_ecommerce_type"

                        label="전자상거래유형"
                        :css-variables="{'--label-width': '14rem'}"

                        :options="ecommerceTypeOptions"
                        desc-msg=""
                    > </input-td-style>
                    <input-td-style
                        class="input"
                        type="text"
                        input-size="small"

                        ref="h_customs_agency_eng_name"
                        name="h_customs_agency_eng_name"
                        v-model="columns.h_customs_agency_eng_name"

                        label="구매/배송대행업체 영문상호"
                        :css-variables="{'--label-width': '14rem'}"

                        desc-msg="배송대행인경우 필수 기입"
                    > </input-td-style>

                    <div class="mb-0d5rem border-box p-0d5rem uk-text-left">
                        <i class="material-icons">info</i>
                        [전자상거래유형] [구매/배송대행업체 영문상호] 입력하지 않으셔도 등록됩니다.
                    </div>

                </app-shipping-reg-fieldset>


            </div>
            <div class="w-46rem">
                <!-- 포장요청 -->
                <app-shipping-reg-fieldset class="mb-1rem etc" title="포장요청">
                    <!-- 포장방법 신청안함 안내 -->
                    <div class="uk-text-left">
                        <app-guide-label-pack-type-none
                            popup-direction="bottom-left"
                        ></app-guide-label-pack-type-none>
                    </div>



                    <input-td-style
                        class="input"
                        type="radio"
                        input-size="small"

                        ref="h_pack_type"
                        name="h_pack_type"
                        v-model="columns.h_pack_type"

                        label="포장방법"
                        :css-variables="{'--label-width': '6rem'}"

                        :options="packTypeOptions"
                    > </input-td-style>
                    <input-td-style
                        class="input"
                        type="radio"
                        input-size="small"

                        ref="h_safety_pack_type"
                        name="h_safety_pack_type"
                        v-model="columns.h_safety_pack_type"

                        label="안전포장"
                        :css-variables="{'--label-width': '6rem'}"

                        :options="safetyPackTypeOptions"
                    > </input-td-style>


                    <input-td-style
                        class="input"
                        type="textarea"
                        input-size="small"

                        ref="h_pack_request"
                        name="h_pack_request"
                        v-model="columns.h_pack_request"

                        label="직접작성"
                        :css-variables="{'--label-width': '6rem'}"

                        :textarea-rows="3"
                        placeholder="포장요청사항을 작업자가 이해하기 쉽도록 작성하세요"
                    > </input-td-style>


                    <!-- 안전포장 안내문 -->
                    <div class="uk-alert-primary" uk-alert>
                        <a class="uk-alert-close" uk-close></a>
                        <strong>안전포장 안함</strong> : 포장미흡으로 인한 책임을 고넬로에 물을 수 없습니다<br />
                        <strong>반드시 안전포장</strong> : 전자제품, 음향기기, 컴퓨터, 유리(도자기), 악기 등..
                        파손위험 높은 고가 상품은 반드시 안전포장 요청하세요.
                        <div class="mt-1rem">
                            <strong>[안전포장] 요청시,</strong> 안전 포장을 위한 자재비(완충재, 박스 등)가 사용되는 경우,  실비 청구 됩니다.  [비용안내]>[포장옵션비용] 참고 바랍니다
                        </div>


                    </div>
                </app-shipping-reg-fieldset>

            </div>





        </div>

    </div>
</template>

<script>
    export default {
        components: {
            'clearance-checker': require('./clearance-checker.vue').default,
            'input-td-style': require('../input/ex/td-style.vue').default,
        },
        props: {
            /**
             * 통관방식 옵션 배열
             */
            customsTypeOptions: Array,
            /**
             * 포장방법 옵션 배열
             */
            packTypeOptions: Array,
            /**
             * 안전포장 옵션 배열
             */
            safetyPackTypeOptions: Array,
            /**
             * 전자상거래유형 옵션 배열
             */
            ecommerceTypeOptions: Array,

            // csrf-token
            csrfToken: String,

            // 로그인 ID
            loginUserId: {
                type: Number,
                default: null
            },

            // 로그인 닉네임
            loginUserNick: {
                type: String,
                default: null
            },

            // 기본배송정보
            defaultSendName: {
                type: String,
                default: null
            },
            defaultSendTel: {
                type: String,
                default: null
            },

            // 초기 설정값
            initColumns: {
                type: Object,
                default: null
            },
        },
        data: function () {
            return {
                /**
                 * 하우스 칼럼정보
                 * 의미는 없는데, input-td-style 요소들이 value 에 대한 미바인딩(동기화X) 에 대한 기능지원이안되서, 
                 * 바인딩하기위해 data 선언함.
                 */
                columns: {
                    // 받는사람
                    h_name: '',
                    h_zipcode: '',
                    h_addr1: '',
                    h_addr2: '',
                    h_cell: '',
                    h_tel: '',

                    // 보내는사람
                    h_send_name: this.defaultSendName,
                    h_send_tel: this.defaultSendTel,

                    // 기타
                    h_sp_code: '',
                    h_sp_memo: '',

                    // 통관정보
                    //h_customs_type: '9',
                    h_customs_clearance_no: '',
                    h_customs_first_name: '',
                    h_customs_last_name: '',
                    h_customs_reg_no: '',
                    h_customs_biz_no: '',
                    h_customs_foreign_no: '',
                    h_customs_passport_no: '',
                    h_customs_nation: '',
                    h_customs_ecommerce_type: 'B',
                    h_customs_agency_eng_name: '',

                    // 포장옵션
                    h_pack_type: '0',
                    h_safety_pack_type: '0',
                    h_pack_request: '',
                },


                // 개인통관고유부호 검사결과 객체
                clearanceChecked: {
                    checkState: null,
                    incorrectMsg: null,
                },

                // 사업자통관 여부
                clearanceByBiz: false,
            };
        },
        mounted: function () {
            // 전역에 현재 컴포넌트 등록
            if (! window.vnodes) {
                window.vnodes = {};
            }
            window.vnodes.appShippingRegHouse = this;

            // 초기값 설정 (주로 테스트용)
            if (this.initColumns) {
                Object.assign(this.columns, this.initColumns);
            }


        },
        computed: {
        },
        watch: {
            // 사업자통관여부 변경시
            clearanceByBiz(by_biz) {
                if (by_biz) {
                    this.columns.h_customs_clearance_no = null;
                    this.columns.h_customs_first_name = null;
                    this.columns.h_customs_last_name = null;
                    this.clearanceChecked.checkState = null;
                    this.clearanceChecked.incorrectMsg = null;
                } else {
                    this.columns.h_customs_biz_no = null;
                }


            },
        },
        methods: {
            /**
             * 각 칼럼에 오류메세지를 설정한다.
             * @param errors 오류메세지 배열
             */
            setErrors: function (errors) {
                var cmp = this;

                // 메세지
                _.forEach(errors, function (msg, key) {
                    if (cmp.$refs[key]) {

                        cmp.$refs[key].setState('error', msg);
                    }
                });
            },

            /**
             * 우편번호 검색 이벤트 리스너
             */
            foundZipcode(value) {
                this.columns.h_zipcode = value.zipcode;
                this.columns.h_addr1 = value.addr;
                // 상세주소 포커싱
                this.$refs.h_addr2.inputFocus();
            },

        }
    }
</script>

<!-- 하위컴포넌트의 요소에 영향을 주기위해서 scope 설정하지않음. -->
<style lang="scss">
    .input {
        margin-bottom: 0.5rem;
    }


    // 필수항목 안내문
    .label-highlight {
        //margin-left: 20px;
        padding: 0.25rem;
        font-size: 1rem;
        color: #000 !important;
        font-weight: bold;
        background-color: #ffff99;
    }
</style>